export const MIN_CREDITS_TO_UNLOCK_AUDIO = 3;
